<template>
	<div class="index-vue">
		<!-- 侧边栏 -->
		<aside :class="asideClassName">
			<!-- logo -->
			<div class="logo-c">
				<img src="../assets/imgs/logo.jpg" alt="logo" class="logo" >
				<!-- <span v-show="isShowAsideTitle">不二账</span> -->
			</div>
			<!-- 菜单栏 -->
			<Menu class="menu" ref="asideMenu" theme="dark" width="100%" @on-select="selectMenuCallback" accordion
				:open-names="openMenus" :active-name="currentPage" @on-open-change="menuChange">
				<!-- 动态菜单 -->
				<div v-for="(item, index) in menuItems" :key="index">
					<Submenu :class="isShowAsideTitle? '' : 'shrink'" v-if="item.children && item.children.length>0" :name="index">
						<template slot="title">
							<img class="menu-item-img" :src="'/static/imgs/'+item.menuIcon" >
							<span v-show="isShowAsideTitle"> {{item.text}}</span>
						</template>
						<div v-for="(subItem, i) in item.children" :key="index + i">
							<Submenu :class="isShowAsideTitle? '' : 'shrink'" v-if="subItem.children && subItem.children.length>0"
								:name="index + '-' + i">
								<template slot="title">
									<img class="menu-item-img" :src="'/static/imgs/'+subItem.menuIcon" >
									<span v-show="isShowAsideTitle"> {{subItem.text}}</span>
								</template>
								<template v-for="(threeItem, k) in subItem.children">
									<a href="https://www.baidu.com" target="_blank" :key="index + i + k"
										v-if="threeItem.isExternal">
										<MenuItem :class="isShowAsideTitle? '' : 'shrink'" class="menu-level-3"
											:name="'external-link-' + index + i + k">
										<template v-if="!threeItem.hidden">
											<a :href="threeItem.url" target="_blank" class="external">
												<img class="menu-item-img" :src="'/static/imgs/'+threeItem.menuIcon" >
												<span v-show="isShowAsideTitle"> {{threeItem.text}}</span>
											</a>
										</template>
										</MenuItem>
									</a>
									<MenuItem v-else :class="isShowAsideTitle? '' : 'shrink'" class="menu-level-3"
										:name="threeItem.name" :key="index + i + k">
									<template v-if="!threeItem.hidden">
										<img class="menu-item-img" :src="'/static/imgs/'+threeItem.menuIcon" >
										<span v-show="isShowAsideTitle"> {{threeItem.text}}</span>
									</template>
									</MenuItem>
								</template>
							</Submenu>
							<template v-else-if="!subItem.hidden">
								<a :href="subItem.url" v-if="subItem.isExternal" target="_blank" class="external">
									<MenuItem :class="isShowAsideTitle? '' : 'shrink'"
										:name="'external-link-' + index + '-' + i">
										<img class="menu-item-img" :src="'/static/imgs/'+subItem.menuIcon" >
									<span v-show="isShowAsideTitle"> {{subItem.text}}</span>
									</MenuItem>
								</a>
								<MenuItem v-else :class="isShowAsideTitle? '' : 'shrink'" :name="subItem.name">
								<img class="menu-item-img" :src="'/static/imgs/'+subItem.menuIcon" >
								<span v-show="isShowAsideTitle"> {{subItem.text}}</span>
								</MenuItem>
							</template>
						</div>
					</Submenu>
					<template v-else-if="!item.hidden">
						<a :href="item.url" v-if="item.isExternal" target="_blank" class="external">
							<MenuItem :class="isShowAsideTitle? '' : 'shrink'" :name="'external-link-' + index">
							<img class="menu-item-img" :src="'/static/imgs/'+item.menuIcon" >
							<span v-show="isShowAsideTitle"> {{item.text}}</span>
							</MenuItem>
						</a>
						<MenuItem v-else :class="isShowAsideTitle? '' : 'shrink'" :name="item.name">
						<img class="menu-item-img" :src="'/static/imgs/'+item.menuIcon" >
						<span v-show="isShowAsideTitle"> {{item.text}}</span>
						</MenuItem>
					</template>
				</div>
			</Menu>
		</aside>

		<!-- 右侧部分 -->
		<section class="sec-right">
			<!-- 头部 -->
			<div class="top-c">
				<header>
					<div class="h-left">
						<div class="pointer" @click="isShrinkAside" title="收缩/展开">
							<Icon type="ios-apps" />
						</div>
						<!-- 面包屑功能 -->
						<p class="crumbs">{{crumbs}}</p>
					</div>
					<div class="h-right">
						<!-- 消息 -->
						<div class="notice-c" @click="info" title="查看新消息">
							<div :class="{newMsg: hasNewMsg}"></div>
							<Icon type="ios-notifications-outline" />
						</div>
						<!-- 用户头像 -->
						<div class="user-img-c">
							<Avatar id="head-img-ava" :src="userImg" size="40" />
						</div>

						<!-- 下拉菜单 -->
						<Dropdown trigger="click" @on-click="userOperate" @on-visible-change="showArrow">
							<div class="pointer">
								<span>{{userName}}</span>
								<Icon v-show="arrowDown" type="md-arrow-dropdown" />
								<Icon v-show="arrowUp" type="md-arrow-dropup" />
							</div>
							<DropdownMenu slot="list">
								<!-- name标识符 -->
								<DropdownItem name="1">基本资料</DropdownItem>
								<Dropdown placement="right-start">
									<DropdownItem divided>
										<Icon type="ios-arrow-back" style="font-size: 14px;color: #000;" />
										切换店铺
									</DropdownItem>
									<template #list>
										<DropdownMenu>
											<DropdownItem :name="item.code" v-for="(item,index) in shops" :key="index" :selected="item.code==userWorkShop">
												{{item.shopName}}
											</DropdownItem>
										</DropdownMenu>
									</template>
								</Dropdown>
								<DropdownItem divided name="2">退出登陆</DropdownItem>
							</DropdownMenu>
						</Dropdown>
					</div>
				</header>

				<!-- 标签栏 -->
				<div class="div-tags">
					<ul class="ul-c">
						<li v-for="(item, index) in tagsArry" :key="index" :class="{active: isActive(item.name)}"
							@click="activeTag(index)">
							<a class="li-a">
								{{item.text}}
							</a>
							<Icon size="16" @click="closeTag(index)" type="md-close" />
						</li>
					</ul>
					<!-- 标签栏相关功能 -->
					<div class="div-icons">
						<div class="refresh-c" @click="reloadPage" title="刷新当前标签页">
							<Icon type="md-refresh" />
						</div>
						<div class="tag-options" title="关闭标签">
							<Dropdown trigger="click" @on-click="closeTags">
								<Icon type="ios-options" />
								<DropdownMenu slot="list">
									<DropdownItem name="1">关闭其它标签</DropdownItem>
									<DropdownItem name="2">关闭所有标签</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
					</div>
				</div>
			</div>
			<!-- 页面主体 -->
			<div class="main-content">
				<div class="view-c">
					<keep-alive :include="keepAliveData">
						<!-- 子页面 -->
						<router-view v-if="isShowRouter" />
					</keep-alive>
				</div>
			</div>
		</section>

		<Modal v-model="userInfoModal" draggable sticky scrollable :width="550">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/bianjiyonghu.png" class="jxyd-imgicon" />
				<span> 操作用户</span>
			</p>
			<Form ref="formUser" :model="formUser" :label-width="70" :rules="ruleUser">
				<table style="width:100%;background-color:#fff;padding:20px;border-radius:5px;">
					<tr>
						<td rowspan="2">
							<Upload action="/file/file/UploadImg" :show-upload-list="false" :max-size="2048"
								:format="['jpg','jpeg','png','gif']" :on-format-error="uploadImgFormatError"
								:on-exceeded-size="uploadImgSizeError" :on-success="upLoadSuccess"
								:on-error="upLoadError">
								<Avatar id="head-img-ava" :src="formUser.headImg" size="100" />
							</Upload>
						</td>
						<td>
							<Form-item label="用户名" prop="userDisplayName">
								<Input v-model="formUser.userDisplayName" placeholder="请输入" size="large" />
							</Form-item>
						</td>
					</tr>
					<tr>
						<td>
							<Form-item label="账号" prop="loginCode">
								<Input v-model="formUser.loginCode" placeholder="请输入" size="large" />
							</Form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<Form-item label="密码" prop="pwd">
								<Input type="password" v-model="formUser.pwd" placeholder="请输入" size="large" />
							</Form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<Form-item label="确认密码" prop="pwdCheck">
								<Input type="password" v-model="formUser.pwdCheck" placeholder="请输入" size="large" />
							</Form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<Form-item label="性别">
								<Radio-group v-model="formUser.sex" size="large">
									<Radio label="1">男</Radio>
									<Radio label="0">女</Radio>
								</Radio-group>
							</Form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<Form-item label="身份证" prop="identityId">
								<Input v-model="formUser.identityId" placeholder="请输入" size="large" />
							</Form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<Form-item label="电话" prop="telePhone">
								<Input v-model="formUser.telePhone" placeholder="请输入" size="large" />
							</Form-item>
						</td>
					</tr>
				</table>
			</Form>
			<div slot="footer">
				<Button @click="userInfoModal = false;">取消</Button>
				<Button type="primary" @click="userSubmit('formUser')">确定</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		resetTokenAndClearUser
	} from '../utils'
	import request from '@/utils/request'
	export default {
		name: 'index',
		data() {
			return {
				// 用于储存页面路径
				paths: {},
				// 当前显示页面
				currentPage: '',
				openMenus: [], // 要打开的菜单名字 name属性
				menuCache: [], // 缓存已经打开的菜单
				hasNewMsg: true, // 是否有新消息
				isShowRouter: true,
				msgNum: '10', // 新消息条数
				// 标签栏         标签标题     路由名称
				// 数据格式 {text: '首页', name: 'home'}
				// 用于缓存打开的路由 在标签栏上展示
				tagsArry: [],
				arrowUp: false, // 用户详情向上箭头
				arrowDown: true, // 用户详情向下箭头
				isShowAsideTitle: true, // 是否展示侧边栏内容
				main: null, // 页面主要内容区域
				asideClassName: 'aside-big', // 控制侧边栏宽度变化
				asideArrowIcons: [], // 缓存侧边栏箭头图标 收缩时用
				// 面包屑
				crumbs: '主页',
				userName: '',
				userImg: '',
				// 主页路由名称
				home: 'home',
				userInfoModal: false,
				formUser: {
					id: 0,
					loginCode: '',
					pwd: '',
					pwdCheck: '',
					userDisplayName: '',
					headImg: '',
					sex: '1',
					identityId: '',
					telePhone: '',
					accountStatus: '0',
					creator: parseInt(localStorage.getItem("userId"))
				},
				ruleUser: {
					loginCode: [{
						required: true,
						message: '请填写账号',
						trigger: 'blur'
					}],
					pwd: [{
						validator: this.validatePass,
						trigger: 'blur'
					}],
					pwdCheck: [{
						validator: this.validatePassCheck,
						trigger: 'blur'
					}],
					userDisplayName: [{
						required: true,
						message: '请填写用户名',
						trigger: 'blur'
					}],
					identityId: [{
							required: true,
							message: '请填写身份证',
							trigger: 'blur'
						},
						{
							type: 'string',
							min: 18,
							max: 18,
							message: '身份证号必须为18位',
							trigger: 'blur'
						}
					],
					telePhone: [{
						type: 'string',
						max: 11,
						message: '电话号最大为11位',
						trigger: 'blur'
					}]
				},
				shops: [],
				currentWorkShop:''
			}
		},
		mounted() {
			// 第一个标签
			const name = this.$route.name
			this.currentPage = name
			this.tagsArry.push({
				text: this.nameToTitle[name],
				name,
				query:{}
			})

			// 根据路由打开对应的菜单栏
			this.openMenus = this.getMenus(name)
			this.$nextTick(() => {
				this.$refs.asideMenu.updateOpened()
			})

			// 设置用户信息
			this.userName = localStorage.getItem('userName')
			this.userImg = localStorage.getItem('userImg')
			this.userWorkShop = localStorage.getItem('workshop')
			this.main = document.querySelector('.sec-right')
			this.asideArrowIcons = document.querySelectorAll('aside .ivu-icon-ios-arrow-down')

			// 监听窗口大小 自动收缩侧边栏
			this.monitorWindowSize()

			this.getStores();
		},
		watch: {
			$route(to) {
				const name = to.name
				this.currentPage = name
				if (name == 'error') {
					this.crumbs = '404'
					return
				}
				if (!this.keepAliveData.includes(name)) {
					// 如果标签超过8个 则将第一个标签删除
					if (this.tagsArry.length == 8) {
						this.tagsArry.shift()
					}
					this.tagsArry.push({
						name,
						text: this.nameToTitle[name],
						query:to.query?to.query:{}
					})
				}else{
					for(let i = 0; i< this.tagsArry.length;i++){
						if(this.tagsArry[i].name == name){
							this.tagsArry[i].query = to.query;
							break;
						}
					}
				}

				setTimeout(() => {
					this.crumbs = this.paths[name]
				}, 0)
			},
		},
		computed: {
			// 菜单栏
			menuItems() {
				return this.$store.state.menuItems
			},
			// 需要缓存的路由
			keepAliveData() {
				return this.tagsArry.map(item => item.name)
			},
			// 由于iView的导航菜单比较坑 只能设定一个name参数
			// 所以需要在这定义组件名称和标签栏标题的映射表 有多少个页面就有多少个映射条数
			nameToTitle() {
				const obj = {}
				this.menuItems.forEach(e => {
					this.processNameToTitle(obj, e)
				})
				return obj
			},
		},
		methods: {
			getMenus(name) {
				let menus
				const tagTitle = this.nameToTitle[name]
				for (let i = 0, l = this.menuItems.length; i < l; i++) {
					const item = this.menuItems[i]
					menus = []
					menus[0] = i
					if (item.text == tagTitle) {
						return menus
					}

					if (item.children) {
						for (let j = 0, ll = item.children.length; j < ll; j++) {
							const child = item.children[j]
							menus[1] = i + '-' + j
							menus.length = 2
							if (child.text == tagTitle) {
								return menus
							}

							if (child.children) {
								for (let k = 0, lll = child.children.length; k < lll; k++) {
									const grandson = child.children[k]
									menus[2] = i + '-' + j + '-' + k
									if (grandson.text == tagTitle) {
										return menus
									}
								}
							}
						}
					}
				}
			},
			getStores() {
				let self = this
				request.get('/api/ShopToUser/GetShopOfUser', {
					params: {
						userId: localStorage.getItem('userId')
					}
				}).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '获取所属店铺失败'
						});
						return;
					}
					self.shops = result.data;
				}).catch(function(error) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '获取所属店铺失败'
					});
				})
			},
			monitorWindowSize() {
				let w = document.documentElement.clientWidth || document.body.clientWidth
				if (w < 1300) {
					this.shrinkAside()
				}

				window.onresize = () => {
					// 可视窗口宽度太小 自动收缩侧边栏
					if (w < 1300 && this.isShowAsideTitle &&
						w > (document.documentElement.clientWidth || document.body.clientWidth)) {
						this.shrinkAside()
					}

					w = document.documentElement.clientWidth || document.body.clientWidth
				}
			},

			// 判断当前标签页是否激活状态
			isActive(name) {
				return this.$route.name === name
			},
			// 跳转页面 路由名称和参数
			gotoPage(name, query) {
				this.currentPage = name
				this.crumbs = this.paths[name]
				this.$router.push({
					name,
					query
				})

				if (!this.keepAliveData.includes(name)) {
					// 如果标签超过8个 则将第一个标签删除
					if (this.tagsArry.length == 8) {
						this.tagsArry.shift()
					}
					this.tagsArry.push({
						name,
						text: this.nameToTitle[name],
						query:query
					})
				}
			},
			// 选择菜单回调函数
			selectMenuCallback(name) {
				if (name.includes('external-link')) return
				this.gotoPage(name)
				this.expandAside()
				setTimeout(() => {
					this.isShowAsideTitle = true
				}, 200)
			},
			// 用户操作
			userOperate(name) {
				switch (name) {
					case '1':
						// 基本资料
						this.openUserModal();
						break;
					case '2':
						resetTokenAndClearUser()
						this.$router.push({
							name: 'login'
						})
						break;
					default:
						localStorage.setItem('workshop',name);
						this.userWorkShop = name
						break;
				}
			},
			// 控制用户三角箭头显示状态
			showArrow(flag) {
				this.arrowUp = flag
				this.arrowDown = !flag
			},
			// 判断
			isShrinkAside() {
				if (this.isShowAsideTitle) {
					this.shrinkAside()
				} else {
					this.expandAside()
				}
			},
			// 收缩
			shrinkAside() {
				for (let i = 0, len = this.asideArrowIcons.length; i < len; i++) {
					this.asideArrowIcons[i].style.display = 'none'
				}

				this.isShowAsideTitle = false
				this.openMenus = []
				this.$nextTick(() => {
					if (this.$refs.asideMenu) {
						this.$refs.asideMenu.updateOpened()
					}
				})

				setTimeout(() => {
					this.asideClassName = ''
					this.main.style.marginLeft = '90px'
				}, 0)
			},
			// 展开
			expandAside() {
				setTimeout(() => {
					this.isShowAsideTitle = true
					for (let i = 0, len = this.asideArrowIcons.length; i < len; i++) {
						this.asideArrowIcons[i].style.display = 'block'
					}

					this.openMenus = this.menuCache
					if (this.$refs.asideMenu) {
						this.$refs.asideMenu.updateOpened()
					}
				}, 200)
				this.asideClassName = 'aside-big'
				this.main.style.marginLeft = '220px'
			},
			// 刷新当前标签页
			reloadPage() {
				let name = this.$route.name
				let index = this.keepAliveData.indexOf(name)
				this.$nextTick(() => {
					if (this.tagsArry.length) {
						this.isShowRouter = false
						this.tagsArry.splice(index, 1)
						this.$nextTick(() => {
							this.tagsArry.splice(index, 0, {
								name,
								text: this.nameToTitle[name]
							})
							this.gotoPage(name)
							this.isShowRouter = true
						})
					} else {
						this.isShowRouter = false
						this.$nextTick(() => {
							this.tagsArry.push({
								name,
								text: this.nameToTitle[name],
								query:this.$route.query
							})
							this.gotoPage(name)
							this.isShowRouter = true
						})
					}
				})
			},
			// 关闭单个标签
			closeTag(i) {
				let name = this.tagsArry[i].name
				this.tagsArry.splice(i, 1)
				window.event.stopPropagation()
				// 如果关闭的是当前标签 则激活前一个标签
				// 如果关闭的是第一个标签 则激活后一个标签
				if (this.tagsArry.length) {
					if (this.isActive(name)) {
						if (i != 0) {
							this.gotoPage(this.tagsArry[i - 1].name)
						} else {
							this.gotoPage(this.tagsArry[i].name)
						}
					}
				} else if (name != this.home) {
					// 如果没有标签则跳往首页
					this.gotoPage(this.home)
				} else {
					this.reloadPage()
				}
			},
			// 根据路由名称关闭页面
			closeName(name) {
				for (let i = 0, len = this.tagsArry.length; i < len; i++) {
					if (this.tagsArry[i].name == name) {
						this.closeTag(i)
						break
					}
				}
			},
			// 批量关闭标签
			closeTags(flag) {
				if (flag == 1) {
					// 关闭其它标签
					this.tagsArry = []
					this.gotoPage(this.$route.name)
				} else {
					// 关闭所有标签
					this.tagsArry = []
					this.gotoPage(this.home)
					this.reloadPage()
				}
			},
			// 激活标签
			activeTag(i) {
				this.gotoPage(this.tagsArry[i].name,this.tagsArry[i].query)
			},
			// 消息通知
			info() {
				const self = this
				this.$Notice.info({
					title: `您有${this.msgNum}条消息`,
					render(h) {
						return h('Button', {
							attrs: {
								type: 'info',
								size: 'small',
							},
							on: {
								click() {
									// 点击查看跳转到消息页
									self.gotoPage('msg')
									self.hasNewMsg = false
									self.msgNum = 0
								},
							},
						}, [
							'点击查看',
						])
					},
				})
			},
			// 菜单栏改变事件
			menuChange(data) {
				this.menuCache = data
			},
			processNameToTitle(obj, data, text) {
				if (data.name) {
					obj[data.name] = data.text
					this.paths[data.name] = text ? `${text} / ${data.text}` : data.text
				}
				if (data.children) {
					data.children.forEach(e => {
						this.processNameToTitle(obj, e, text ? `${text} / ${data.text}` : data.text)
					})
				}
			},
			openUserModal() {
				let self = this;
				request.get('/api/User/GetUser', {
					params: {
						id: parseInt(localStorage.getItem("userId"))
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取用户基本信息失败：" + response.errorMsg
						});
						return;
					}
					self.formUser = response.data;
					self.userInfoModal = true;
				}).catch(function(error) {})
			},
			upLoadSuccess(response, file, fileList) {
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '上传失败：' + response.errorMsg + '!'
					});
					return;
				}
				this.formUser.headImg = response.data[0];
			},
			upLoadError(error, file, fileList) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：' + error + '!'
				});
			},
			uploadImgFormatError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：请上传jpg、png、jpeg、gif格式图片!'
				});
			},
			uploadImgSizeError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：不可上传超过2M大小图片!'
				});
			},
			validatePass(rule, value, callback) {
				if (value === '') {
					callback(new Error('请填写密码'));
				} else {
					if (this.formUser.pwdCheck !== '') {
						// 对第二个密码框单独验证
						this.$refs.formUser.validateField('pwdCheck');
					}
					callback();
				}
			},
			validatePassCheck(rule, value, callback) {
				if (value === '') {
					callback(new Error('请再次确认密码'));
				} else if (value !== this.formUser.pwd) {
					callback(new Error('两次密码输入不一致!'));
				} else {
					callback();
				}
			},
			userSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						let self = this;
						request.post('/api/User/EditUser', self.formUser).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '保存失败:' + response.errorMsg
								});
								return;
							}
							//清空form规则检查
							self.userInfoModal = false;
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '保存成功,请重新登录！'
							});
							resetTokenAndClearUser();
							self.$router.push({
								name: 'login'
							});
						}).catch(function(error) {})
					}
				})
			},
		}
	}
</script>

<style scoped>
	.index-vue {
		height: 100%;
		color: #666;
		min-width: 1200px;
		min-height: 700px;
		overflow-y: auto;
	}

	/* 侧边栏 */
	aside {
		position: absolute;
		top: 0;
		left: 0;
		width: 90px;
		background: #23262e !important;
		height: 100%;
		transition: width .3s;
	}

	.logo-c {
		display: flex;
		align-items: center;
		color: #ffffff;
		font-weight: 600;
		font-size: 15px;
		justify-content: center;
		height: 60px;
		border-radius: 3px;
		overflow: hidden;
		background-color: #0c0c0c !important;
	}

	.logo {
		width: 70px;
	}

	.aside-big {
		width: 220px;
	}

	/* 主体页面 */
	.sec-right {
		height: 100%;
		margin-left: 220px;
		transition: margin-left .3s;
		overflow: hidden;
		background: #f3f7fd;
	}

	/* 主体页面头部 */
	header {
		height: 60px;
		border-bottom: none;
		background: #23262e;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-right: 40px;
		padding-left: 10px;
		font-size: 14px;
	}

	header .ivu-icon {
		font-size: 24px;
		color: #bbe3df;
	}

	.refresh-c {
		margin: 0 30px;
		cursor: pointer;
	}

	.h-right {
		display: flex;
		align-items: center;
	}

	.h-left {
		display: flex;
		align-items: center;
	}

	/*.user-img-c img {
        width: 100%;
    }*/

	.notice-c {
		cursor: pointer;
		position: relative;
	}

	.newMsg {
		position: absolute;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: #FF5722;
		right: 0;
		top: 0;
	}

	.user-img-c {
		margin: 0 40px;
	}

	.tag-options {
		cursor: pointer;
		position: relative;
	}

	.div-tags {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 4px 0;
	}

	.div-icons {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background: #fff;
		height: 34px;
		width: 160px;
		font-size: 18px;
	}

	/* 标签栏 */
	.ul-c {
		height: 34px;
		background: #fff;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 10px;
		overflow: hidden;
		width: calc(100% - 160px);
	}

	.ul-c li {
		border-radius: 3px;
		cursor: pointer;
		font-size: 12px;
		height: 24px;
		padding: 0 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 3px 5px 2px 3px;
		border: 1px solid #e6e6e6;
	}

	a {
		color: #666;
		transition: none;
	}

	.li-a {
		max-width: 80px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.ul-c .ivu-icon {
		margin-left: 6px;
	}

	.active {
		background: rgb(255, 106, 127);
		border: 1px solid rgb(255, 106, 127);
	}

	.active a {
		color: #fff;
	}

	.active .ivu-icon {
		color: #fff;
	}

	/* 主要内容区域 */
	.main-content {
		height: calc(100% - 110px);
		overflow-y: auto;
	}

	.view-c {
		position: relative;
		height: 100%;
		margin: 5px 10px;
	}

	.pointer {
		cursor: pointer;
		color: rgba(255, 255, 255, .7)
	}

	.crumbs {
		margin-left: 10px;
		color: rgba(255, 255, 255, .7);
		cursor: default;
	}

	.menu-level-3 .ivu-icon {
		font-size: 18px;
	}

	.shrink {
		text-align: center;
	}

	.external {
		color: rgba(255, 255, 255, .7);
	}

	.external>i {
		margin-right: 6px;
	}
	
	.menu-item-img{
		width: 20px;
		height: 20px;
	}
	
	.modal-header{
		display: flex;
		justify-content: left;
		align-items: center;
	}
</style>